import {
  APP_RESET,
  CLEAR_STORAGE,
  CLOSE_MODAL,
  SET_ACTIVE_TAB,
  SET_ALERT,
  SET_BACK_URL,
  SET_CONFIRM,
  SET_DISPLAY_ALERT,
  SET_EXPANDED_SIDEBAR,
  SET_FAVORITE_REPORTS,
  SET_FISCAL_YEAR,
  SET_FISCAL_YEARS,
  SET_FROM_DATE,
  SET_LOADING,
  SET_MODAL,
  SET_OPEN_ALL_REPORTS,
  SET_OPEN_DRAWER,
  SET_PAYMENT_DATA,
  SET_QUICK_ACCESS,
  SET_SECRET_VIEW,
  SET_SELECTED_REPORT_TYPE,
  SET_SENDING_REQUEST,
  SET_TABLE_COLUMNS,
  SET_TABLE_ORDER,
  SET_TO_DATE,
  SET_TOGGLE,
  SET_TOKEN,
  SET_USER,
  SET_WIDGETS,
  SET_GUIDE,
  SET_GUIDE_DATA,
  SET_DASHBOARD_GUIDE,
  SET_CREDIT_BALANCE,
  SET_APP_SETTINGS,
  SET_EXPANDED_NOTIFICATION,
  SET_IS_DEMO,
  SET_LABEL_SETTINGS, APP_FORCE_LOGOUT,
} from "../../constants/appConstants";

export const appReset = () => {
  return {
    type: APP_RESET,
  };
};

export const clearStorage = () => {
  return {
    type: CLEAR_STORAGE,
  };
};

export const appSetLoading = (loading = true) => {
  return {
    type: SET_LOADING,
    loading,
  };
};

export const appSetToggle = (toggle = true) => {
  return {
    type: SET_TOGGLE,
    toggle,
  };
};

export const appSetModal = (modalProps, show = true) => {
  return {
    type: SET_MODAL,
    show,
    modalProps,
  };
};

export const appCloseModal = () => {
  return {
    type: CLOSE_MODAL,
  };
};

export const appSetSendingRequest = (sendingRequest, requestingApi = null) => {
  return {
    type: SET_SENDING_REQUEST,
    sendingRequest,
    requestingApi,
  };
};

export const appSetAlert = (alertMessage, alertType, alertDisplay = true) => {
  return {
    type: SET_ALERT,
    alertMessage,
    alertType,
    alertDisplay,
  };
};

export const appDisplayAlert = (alertDisplay = true) => {
  return {
    type: SET_DISPLAY_ALERT,
    alertDisplay,
  };
};

export const appSetActiveTab = (activeTab) => {
  return {
    type: SET_ACTIVE_TAB,
    activeTab,
  };
};

export const appSetBackUrl = (backUrl, backData) => {
  return {
    type: SET_BACK_URL,
    backUrl,
    backData,
  };
};

export const setSecretView = (secretView) => {
  return {
    type: SET_SECRET_VIEW,
    secretView,
  };
};

export const setConfirm = (title, action, callback,message,ignoreAction) => {
  return {
    type: SET_CONFIRM,
    title,
    action: action,
    callback: callback,
    message,
    ignoreAction

  };
};

export const setPaymentData = (paymentData) => {
  return {
    type: SET_PAYMENT_DATA,
    paymentData,
  };
};

export const setToken = (token) => {
  return {
    type: SET_TOKEN,
    token,
  };
};

export const setUser = (user) => {
  return {
    type: SET_USER,
    user,
  };
};
export const appSetWidget = (widgets) => {
  return {
    type: SET_WIDGETS,
    widgets,
  };
};

export const appSetQuickAccess = (item, list, dispatch) => {
  // try {
    // const index = list.findIndex((object) => object.name === item.name);
    // if (index === -1) {
    //   if (list.length >= 11) {
    //     dispatch(apiSetAlert(Messages.dashboardQuickAccessLimit, "warning"));
    //     return;
    //   }
    //   list.push(item);
    //   return {
    //     type: SET_QUICK_ACCESS,
    //     quickAccess: list,
    //   };
    // }
    // const filtered = list.filter((object) => object.name !== item.name);
    return {
      type: SET_QUICK_ACCESS,
      quickAccess: list,
    };
  // } catch {
  //   return {
  //     type: SET_QUICK_ACCESS,
  //     quickAccess: [],
  //   };
  // }
};

export const appSetTogetherQuickAccess = (quickAccess) => {
  return {
    type: SET_QUICK_ACCESS,
    quickAccess,
  };
};

export const appSetFavoriteReports = (item, list) => {
  try {
    const index = list.findIndex((object) => object.title === item.title);
    if (index === -1) {
      list.push(item);
      return {
        type: SET_FAVORITE_REPORTS,
        favoriteReports: list,
      };
    }
    const filtered = list.filter((object) => object.title !== item.title);
    return {
      type: SET_FAVORITE_REPORTS,
      favoriteReports: filtered,
    };
  } catch {
    return {
      type: SET_FAVORITE_REPORTS,
      favoriteReports: [item],
    };
  }
};

export const appSetOpenAllReports = (openReports) => {
  return {
    type: SET_OPEN_ALL_REPORTS,
    openReports,
  };
};
export const appSelectedReportType = (selectedReportType) => {
  return {
    type: SET_SELECTED_REPORT_TYPE,
    selectedReportType,
  };
};

export const addOpenDrawer = (open, component, anchor, drawerProps) => {
  return {
    type: SET_OPEN_DRAWER,
    open,
    component,
    anchor,
    drawerProps,
  };
};
export const appSetTableColumns = (tableKey, columns, currentState) => {
  const index = currentState.findIndex((object) => object.key === tableKey);
  if (index === -1) {
    return {
      type: SET_TABLE_COLUMNS,
      payload: [
        ...currentState,
        {
          key: tableKey,
          columns,
        },
      ],
    };
  }
  return {
    type: SET_TABLE_COLUMNS,
    payload: [
      ...currentState.filter((object) => object.key !== tableKey),
      {
        key: tableKey,
        columns,
      },
    ],
  };
};
export const appSetTableOrder = (tableKey, columns, currentState) => {
  const index = currentState.findIndex((object) => object.key === tableKey);
  if (index === -1) {
    return {
      type: SET_TABLE_ORDER,
      payload: [
        ...currentState,
        {
          key: tableKey,
          columns,
        },
      ],
    };
  }
  return {
    type: SET_TABLE_ORDER,
    payload: [
      ...currentState.filter((object) => object.key !== tableKey),
      {
        key: tableKey,
        columns,
      },
    ],
  };
};

export const appSetFromDate = (fromDate,toDate,) => {
  return {
    type: SET_FROM_DATE,
    fromDate,
  };
};
export const appSetToDate = (toDate) => {
  return {
    type: SET_TO_DATE,
    toDate,
  };
};
export const appSetExpandedSidebar = (sidebarExpanded) => {
  return {
    type: SET_EXPANDED_SIDEBAR,
    sidebarExpanded,
  };
};
export const appSetFiscalYears = (fiscalYears) => {
  return {
    type: SET_FISCAL_YEARS,
    fiscalYears,
  };
};
export const appSetFiscalYear = (fiscalYear) => {
  return {
    type: SET_FISCAL_YEAR,
    fiscalYear,
  };
};
export const appSetGuide = () => {
  return {
    type: SET_GUIDE,
  };
};
export const appSetGuideData = (list) => {
  return {
    type: SET_GUIDE_DATA,
    list,
  };
};
export const appSetDashboardGuideData = (value) => {
  return {
    type: SET_DASHBOARD_GUIDE,
    value,
  };
};
export const appSetCreditBalance = (value) => {
  return {
    type: SET_CREDIT_BALANCE,
    value,
  };
};
export const appSetSettings = (value) => {
  return {
    type: SET_APP_SETTINGS,
    value,
  };
};
export const appSetExpandedNotification = (notificationExpanded) => {
  return {
    type: SET_EXPANDED_NOTIFICATION,
    notificationExpanded,
  };
};
export const appSetIsDemo = (isDemo) => {
  return {
    type: SET_IS_DEMO,
    isDemo,
  };
};
export const appSetLabelSettings = (labelSettings) => {
  return {
    type: SET_LABEL_SETTINGS,
    labelSettings,
  };
};

export const appForceLogout = (force = true) => {
  return {
    type: APP_FORCE_LOGOUT,
    force
  };
};
